class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onScroll = this.handleScroll.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    const overlay = this.querySelector('.cart-notification-overlay');
    if (overlay) {
      overlay.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.close();
      });
    }
  }

  handleScroll() {
    if (this.openedAt && Date.now() - this.openedAt < 450) {
      this.openScrollY = window.scrollY || window.pageYOffset || 0;
      return;
    }
    const currentY = window.scrollY || window.pageYOffset || 0;
    if (Math.abs(currentY - this.openScrollY) > 40) {
      this.close();
    }
  }

  open() {
    this.openedAt = Date.now();
    this.openScrollY = window.scrollY || window.pageYOffset || 0;
    this.notification.classList.add('animate', 'active');
    this.classList.add('active');

    if (this._onTransitionEnd) {
      this.notification.removeEventListener('transitionend', this._onTransitionEnd);
    }
    this._onTransitionEnd = (evt) => {
      if (evt.target !== this.notification) return;
      this.notification.removeEventListener('transitionend', this._onTransitionEnd);
      this._onTransitionEnd = null;
      const savedScrollY = window.scrollY || window.pageYOffset || 0;
      this.notification.focus({ preventScroll: true });
      trapFocus(this.notification);
      if (Math.abs((window.scrollY || window.pageYOffset || 0) - savedScrollY) > 0) {
        window.scrollTo({ top: savedScrollY, behavior: 'instant' });
      }
      this.openScrollY = window.scrollY || window.pageYOffset || 0;
    };
    this.notification.addEventListener('transitionend', this._onTransitionEnd);

    document.body.addEventListener('click', this.onBodyClick);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  close() {
    if (this._onTransitionEnd) {
      this.notification.removeEventListener('transitionend', this._onTransitionEnd);
      this._onTransitionEnd = null;
    }
    this.notification.classList.remove('active');
    this.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    window.removeEventListener('scroll', this.onScroll);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const shippingContainer = document.getElementById('cart-notification-shipping');
    if (shippingContainer && parsedState.sections && parsedState.sections['cart-notification-product']) {
      const prevBar = shippingContainer.querySelector('.cart-notification-shipping__bar');
      const prevWidth = prevBar ? prevBar.style.width : '0%';
      const parsedProductSection = new DOMParser().parseFromString(
        parsedState.sections['cart-notification-product'],
        'text/html'
      );
      const shippingSource = parsedProductSection.getElementById('cart-notification-shipping-data');
      if (shippingSource) {
        shippingContainer.innerHTML = shippingSource.innerHTML;
        const newBar = shippingContainer.querySelector('.cart-notification-shipping__bar');
        if (newBar) {
          const targetWidth = newBar.getAttribute('data-target-width') || newBar.style.width;
          newBar.style.transition = 'none';
          newBar.style.width = prevWidth;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              newBar.style.transition = '';
              newBar.style.width = targetWidth;
            });
          });
        }
      }
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.closest && target.closest('.peachito-qa-wrapper, .quick-add, product-form')) {
      return;
    }
    if (target !== this.notification && !target.closest('.cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      evt.preventDefault();
      evt.stopPropagation();
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
